import { useState, useEffect } from "react";
import { STORAGE_KEYS } from "@/config/storageKeys";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight, X, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { trackStickyCTAClick } from "@/lib/analytics";

const StickyCTABar = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isAuthenticated || dismissed) return;
    if (localStorage.getItem(STORAGE_KEYS.STICKY_DISMISSED)) {
      setDismissed(true);
      return;
    }

    const handleScroll = () => {
      // Afficher après 30% de scroll
      const scrolled = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      if (scrolled > 0.3) setVisible(true);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isAuthenticated, dismissed]);

  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    localStorage.setItem(STORAGE_KEYS.STICKY_DISMISSED, "1");
  };

  if (!visible || isAuthenticated || dismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 px-4 pb-4"
      style={{ animation: "slideUpFull 0.4s ease-out" }}>
      <div className="max-w-3xl mx-auto glass rounded-2xl border border-primary/20 px-5 py-3 flex items-center gap-4 shadow-2xl">
        <div className="w-8 h-8 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0">
          <Zap className="w-4 h-4 text-primary" />
        </div>
        <p className="text-sm text-slate-300 flex-1">
          <span className="text-white font-semibold">{t('stickyCTA.highlight')} </span>
          {t('stickyCTA.text')}
        </p>
        <Link to="/register" className="flex-shrink-0" onClick={trackStickyCTAClick}>
          <Button size="sm" className="btn-glow bg-primary-strong hover:bg-primary-strong/90 gap-1">
            {t('stickyCTA.cta')} <ArrowRight className="w-4 h-4" />
          </Button>
        </Link>
        <button onClick={handleDismiss} className="text-slate-400 hover:text-white transition-colors flex-shrink-0">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default StickyCTABar;
